import networkType from './{networkType}';
export default { networkType };
